import Layout from '@/layout/index.vue'

const myProfileRouter = {
  path: '/myProfile',
  component: Layout,
  redirect: 'noredirect',
  name: 'MyProfile',
  meta: {
    title: 'myProfile',
    icon: 'user-line',
  },
  children: [
    {
      path: '/quotedPrice/index/:id/:customerId?',
      name: 'quotedPrice',
      component: () => import('@/views/quotedPrice/index'),
    },
    {
      path: '/quotedPrice/detail/:queryType/:id/:queryId?',
      name: 'quotedPriceDeatil',
      component: () => import('@/views/quotedPrice/detail'),
    },
    {
      path: 'historyPrice',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */ '@/views/myProfile/historyPrice.vue'
        ),
      name: 'historyPrice',
      meta: {
        title: 'historyPrice',
        noCache: true,
      },
    },
    {
      path: 'skuInfo',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */ '@/views/myProfile/skuInfo.vue'
        ),
      name: 'SkuInfo',
      meta: {
        title: 'skuInfo',
        noCache: true,
      },
    },
    {
      path: 'storeManagement',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */ '@/views/myProfile/storeManagement.vue'
        ),
      name: 'StoreManagement',
      meta: {
        title: 'storeManagement',
        noCache: true,
      },
    },
    {
      path: 'pickupAddress',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */ '@/views/myProfile/pickupAddress.vue'
        ),
      name: 'PickupAddress',
      meta: {
        title: 'pickupAddress',
        noCache: true,
      },
    },

    {
      path: 'shippingAddress',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */ '@/views/myProfile/shippingAddress.vue'
        ),
      name: 'ShippingAddress',
      meta: {
        title: 'shippingAddress',
        noCache: true,
      },
    },
    {
      path: 'invoiceTitle',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */ '@/views/myProfile/invoiceTitle.vue'
        ),
      name: 'InvoiceTitle',
      meta: {
        title: 'invoiceTitle',
        noCache: true,
      },
    },
    {
      path: 'importerInformation',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */ '@/views/myProfile/importerInformation.vue'
        ),
      name: 'ImporterInformation',
      meta: {
        title: 'importerInformation',
        noCache: true,
      },
    },
    {
      path: 'warehouseInfoMaintenance',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */ '@/views/myProfile/warehouseInfoMaintenance.vue'
        ),
      name: 'warehouseInfoMaintenance',
      meta: {
        title: 'warehouseInfoMaintenance',
        noCache: true,
      },
    },
    {
      path: 'senderInformation',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */ '@/views/myProfile/senderInformation.vue'
        ),
      name: 'SenderInformation',
      meta: {
        title: 'senderInformation',
        noCache: true,
      },
    },
    {
      path: 'trackingNotificationSettings',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */
          '@/views/myProfile/trackingNotificationSettings.vue'
        ),
      name: 'TrackingNotificationSettings',
      meta: {
        title: 'trackingNotificationSettings',
        noCache: true,
      },
    },
    {
      path: 'overseasWarehouseTrackingNotificationSettings',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */
          '@/views/myProfile/overseasWarehouseTrackingNotificationSettings.vue'
        ),
      name: 'OverseasWarehouseTrackingNotificationSettings',
      meta: {
        title: 'overseasWarehouseTrackingNotificationSettings',
        noCache: true,
      },
    },
    {
      path: 'customerProfileEmailNotification',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */
          '@/views/myProfile/customerProfileEmailNotification.vue'
        ),
      name: 'CustomerProfileEmailNotification',
      meta: {
        title: 'customerProfileEmailNotification',
        noCache: true,
      },
    },
    {
      path: 'manageOtherFiles',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */
          '@/views/myProfile/customerProfileEmailNotification.vue'
        ),
      name: 'manageOtherFiles',
      meta: {
        title: 'manageOtherFiles',
        noCache: true,
      },
    },
    {
      path: 'file',
      component: () =>
        import(
          /* webpackChunkName: "bar-chart" */
          '@/views/myProfile/file.vue'
        ),
      name: 'file',
      meta: {
        title: 'file',
        noCache: true,
      },
    },
    {
      path: 'teapplixOauth',
      component: () => import('@/views/myProfile/teapplixOauth.vue'),
      name: 'teapplixOauth',
      meta: {
        title: 'teapplixOauth',
        noCache: true,
      },
    },
    {
      path: 'mabangOauth',
      component: () => import('@/views/myProfile/mabangOauth.vue'),
      name: 'mabangOauth',
      meta: {
        title: 'mabangOauth',
        noCache: true,
      },
    },
    {
      path: 'ecCangOauth',
      component: () => import('@/views/myProfile/ecCangOauth.vue'),
      name: 'ecCangOauth',
      meta: {
        title: 'ecCangOauth',
        noCache: true,
      },
    },
    {
      path: 'apiAuthorization',
      component: () => import('@/views/myProfile/apiAuthorization.vue'),
      name: 'apiAuthorization',
      meta: {
        title: 'apiAuthorization',
        noCache: true,
      },
    },
  ],
}

export default myProfileRouter
